import { getStyle } from './DatanauswertungGenerischStyles';
import { Image, Text, View } from '@react-pdf/renderer';
import { parsePdfSub2 } from '../generisch/helper';
import * as React from 'react';

export function renderDiagramPdf(pngLinks: any[], diagramSize: any[], diagrams: any[], diagramLayout?: string): JSX.Element {
    // console.log(diagramSize, diagrams);
    if (Array.isArray(diagrams) && diagrams.length > 0) {
        const maxHeight = Math.max(...diagramSize.map((d: any) => d.height));
        const spacer = 15;
        const styleDiagrammTitle = getStyle('diagrammTitle', true);
        const styleLegendIcon = getStyle('legendIcon', true);
        const styleLegendTitel = getStyle('legendTitel', true);
        const styleDiagrammWrapper = getStyle('diagrammWrapper', true);

        return (
            <View style={{ width: '100%' }}>
                <View style={{
                    ...styleDiagrammWrapper,
                    ...(diagramLayout === 'column' ? { flexDirection: 'column' } : {})
                }}>
                    {pngLinks.map((link: any, idx: number) => {
                        const style: any = { ...((diagrams[idx].legendProps || {}).style || {}) };
                        let dHeight = maxHeight / 1.5 + spacer;
                        if (diagrams[idx] && diagrams[idx].type === 'PieChart') {
                            dHeight = maxHeight + spacer;
                            if (diagrams[idx].layout === 'row') {
                                dHeight = maxHeight / 3 + spacer;
                            }
                        }
                        if (diagrams[idx] && diagrams[idx].type === 'SimpleBarChart') {
                            const isFlexDirectionColumn: boolean = style.flexDirection === 'column';
                            const legendHeight: number = ([...(diagrams[idx].customLegends || []), ...diagrams[idx].data].length * (isFlexDirectionColumn ? 9 : 5)) - 10 /* marginTop: -10 */;
                            dHeight = diagramSize[idx].height + legendHeight;
                            if (isFlexDirectionColumn) {
                                style.maxHeight = legendHeight + 10;
                            }
                        }

                        const styDigm = { ...getStyle('diagramm', true), border: '1 solid gray', boxSizing: 'border-box', height: dHeight };
                        if (idx === pngLinks.length - 1) {
                            styDigm.marginRight = 0;
                        }
                        if (diagramLayout === 'column') {
                            styDigm.width = '100%';
                            if (idx !== 0) {
                                styDigm.marginTop = 10;
                            }
                        }

                        if (diagrams[idx].type === 'PieChart' && diagrams[idx].layout === 'row') {
                            const rad = diagramSize[0].width * 0.7;
                            return (
                                <View style={styDigm} key={`diagram_${idx}`}>
                                    <View style={styleDiagrammTitle}>
                                        <Text>{diagrams[idx] && parsePdfSub2(diagrams[idx].titlePdf, styleDiagrammTitle)}</Text>
                                    </View>
                                    <View style={{ display: 'flex', flexDirection: 'row', padding: 20 }}>
                                        <View style={{ width: '60%' }}>
                                            <Image src={link} style={{ marginTop: -100, marginLeft: -30, width: rad, height: rad }} />
                                        </View>
                                        <View style={{ ...getStyle('legendWrapper', true), width: '40%', justifyContent: 'flex-start' }}>
                                            {diagrams[idx] && Array.isArray(diagrams[idx].legend) &&
                                                diagrams[idx].legend.map((name: any, i: number) => {
                                                    let backgroundColor = 'white';
                                                    if (diagrams[idx] && diagrams[idx].legendIconColor && diagrams[idx].legendIconColor[i]) {
                                                        backgroundColor = diagrams[idx].legendIconColor[i];
                                                    } else if (diagrams[idx] && diagrams[idx].lineColor && diagrams[idx].lineColor[i]) {
                                                        backgroundColor = diagrams[idx].lineColor[i];
                                                    }
                                                    return (
                                                        <View key={`legend-${i}`} style={styleLegendTitel}>
                                                            <View style={{ ...styleLegendIcon, backgroundColor }} />
                                                            <Text>{parsePdfSub2(name, styleLegendTitel)}</Text>
                                                        </View>
                                                    );
                                                })}
                                        </View>
                                    </View>
                                </View>
                            );
                        }

                        if (diagrams[idx].type === 'SimpleBarChart') {
                            return (
                                <View style={styDigm} key={`diagram_${idx}`}>
                                    <View style={styleDiagrammTitle}>
                                        <Text>{diagrams[idx] && parsePdfSub2(diagrams[idx].titlePdf, styleDiagrammTitle)}</Text>
                                    </View>
                                    <Image src={link} style={{ maxWidth: '100%', marginRight: 15 }} />
                                    <View
                                        style={{
                                            ...getStyle('legendWrapper', true), margin: 0, marginTop: -10, padding: 0, paddingLeft: 45,
                                            paddingRight: 30, justifyContent: 'center', boxSizing: 'border-box', ...style
                                        }}
                                    >
                                        {diagrams[idx] && Array.isArray(diagrams[idx].data) && diagrams[idx].data.length &&
                                            [...(diagrams[idx].customLegends || []), ...diagrams[idx].data].map((row: any, i: number) =>
                                                <View key={`legend-${i}`} style={styleLegendTitel}>
                                                    <View style={{ ...styleLegendIcon, backgroundColor: row.color || 'gray' }} />
                                                    <Text>{parsePdfSub2(row.legend, styleLegendTitel)}</Text>
                                                </View>
                                            )}
                                    </View>
                                </View>
                            );
                        }

                        return (
                            <View style={styDigm} key={`diagram_${idx}`}>
                                <View style={styleDiagrammTitle}>
                                    <Text>{diagrams[idx] && parsePdfSub2(diagrams[idx].titlePdf, styleDiagrammTitle)}</Text>
                                </View>
                                <View style={getStyle('legendWrapper', true)}>
                                    {diagrams[idx] && Array.isArray(diagrams[idx].legend) &&
                                        diagrams[idx].legend.map((name: any, i: number) => {
                                            let backgroundColor = 'white';
                                            if (diagrams[idx] && diagrams[idx].legendIconColor && diagrams[idx].legendIconColor[i]) {
                                                backgroundColor = diagrams[idx].legendIconColor[i];
                                            } else if (diagrams[idx] && diagrams[idx].lineColor && diagrams[idx].lineColor[i]) {
                                                backgroundColor = diagrams[idx].lineColor[i];
                                            }
                                            return (
                                                <View key={`legend-${i}`} style={styleLegendTitel}>
                                                    <View style={{ ...styleLegendIcon, backgroundColor }} />
                                                    <Text>{parsePdfSub2(name, styleLegendTitel)}</Text>
                                                </View>
                                            );
                                        })}
                                </View>
                                <Image
                                    src={link}
                                    style={{
                                        maxWidth: '100%', marginTop: 0,
                                        ...(diagrams[idx] && diagrams[idx].type === 'PieChart'
                                            ? { width: diagramSize[0].width, height: diagramSize[0].height } : {}
                                        )
                                    }}
                                />
                            </View>
                        );
                    })}
                </View>
            </View>
        );
    }
}
